import { JSX, useState } from 'react';
import { Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

const ALL_TAB = 'All';

const LogEntries = ({ value }: { value: unknown }): JSX.Element => {
  if (typeof value !== 'string') {
    return (
      <pre style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
        {JSON.stringify(value, null, 2) ?? ''}
      </pre>
    );
  }
  return (
    <>
      {value.split('\n').map((line, i) => (
        <div key={i} style={{ marginTop: i > 0 ? '4px' : 0, wordBreak: 'break-word' }}>
          {line}
        </div>
      ))}
    </>
  );
};

export const StructuredLogViewer = ({ entries }: { entries: [string, unknown][] }): JSX.Element => {
  const [activeTab, setActiveTab] = useState(ALL_TAB);

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        marginLeft: '-24px',
        marginRight: '-24px',
      }}
    >
      <TabContext value={activeTab}>
        <div style={{ flexShrink: 0, borderRight: '1px solid #e0e0e0', overflowY: 'auto' }}>
          <TabList
            orientation="vertical"
            onChange={(_, val: string) => setActiveTab(val)}
            sx={{
              minHeight: 'unset',
              '& .MuiTabs-indicator': { display: 'none' },
              '& .MuiTab-root': {
                alignItems: 'flex-start',
                textAlign: 'left',
                minHeight: '32px',
                padding: '6px 16px',
                textTransform: 'none',
              },
              '& .MuiTab-root.Mui-selected': {
                backgroundColor: 'rgba(25, 118, 210, 0.12)',
                borderLeft: '3px solid #1976d2',
              },
            }}
          >
            <Tab label={ALL_TAB} value={ALL_TAB} />
            {entries.map(([key]) => (
              <Tab key={key} label={key} value={key} />
            ))}
          </TabList>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '0 24px' }}>
          <TabPanel value={ALL_TAB} sx={{ p: 0 }}>
            {entries.map(([key, value]) => (
              <div key={key} style={{ marginBottom: '12px' }}>
                <div style={{ fontWeight: 600, marginBottom: '4px' }}>{key}</div>
                <LogEntries value={value} />
              </div>
            ))}
          </TabPanel>

          {entries.map(([key, value]) => (
            <TabPanel key={key} value={key} sx={{ p: 0 }}>
              <LogEntries value={value} />
            </TabPanel>
          ))}
        </div>
      </TabContext>
    </div>
  );
};
